<div *ngIf="visible" class="sbx-overlay">
  <app-loader [loading]="showLoader" [small]="false"></app-loader>
  <div class="sbx-iframe-header">
    <img class="header-logo" [src]="headerLogoSrc" />
    <i class="material-icons close-btn" *ngIf="allowClose" (click)="close.emit()">close</i>
  </div>
  <iframe
    #sbxIframe
    [src]="url"
    width="100%" height="100%" frameborder="0"
    style="overflow: hidden;"
    (load)="onIframeLoad($event.target)"
  ></iframe>
</div>
